export const JAPAN_LANGUAGE = 'ja-JP';
export const SPANISH_LANGUAGE = 'es-ES';
export const GERMAN_LANGUAGE = 'de-DE';
export const FRENCH_LANGUAGE = 'fr-FR';
export const ITALIAN_LANGUAGE = 'it-IT';

export const TRANSLATION_LOCALES_MAP = new Map<string, string>([
  [JAPAN_LANGUAGE, 'ja'],
  [SPANISH_LANGUAGE, 'es'],
  [GERMAN_LANGUAGE, 'de'],
  [FRENCH_LANGUAGE, 'fr'],
  [ITALIAN_LANGUAGE, 'it'],
]);
